import { useEffect } from "react";

const useSignalRGroupHandler = ({
	connection,
	registerHandler,
	ready,
	groupName,
	messageType,
	handler,
	enabled = true,
	joinMethodName = "JoinGroupAsync",
	leaveMethodName = "LeaveGroupAsync"
}) => {
	useEffect(() => {
		if (!enabled || !connection || !ready || !groupName) {
			return;
		}

		let isActive = true;
		let hasJoined = false;

		const joinGroup = async () => {
			try {
				await connection.invoke(joinMethodName, groupName);

				if (isActive) {
					hasJoined = true;
				}
			}
			catch (e) {
			}
		};

		joinGroup();

		return () => {
			isActive = false;

			if (hasJoined && connection.state === "Connected") {
				connection.invoke(leaveMethodName, groupName).catch(() => {
				});
			}
		};
	}, [connection, ready, groupName, enabled, joinMethodName, leaveMethodName]);

	useEffect(() => {
		if (!enabled || !connection || !ready || !groupName || !messageType || !handler) {
			return;
		}

		const unregister = registerHandler(messageType, groupName, handler);

		return () => {
			unregister();
		};
	}, [connection, registerHandler, ready, groupName, messageType, handler, enabled]);
};

export default useSignalRGroupHandler;